import React from "react";
import useBirthdayManager from "./hooks/useBirthdayManager";
import BirthdayRightContainer from "./BirthdayRightContainer";
import { Grid } from "@mui/material";

const BirthdayReservation: React.FC = () => {
  const {
    birthDayData,
    firstStepMethod,
    secondStepMethod,
    thirdStepMethod,
    lines,
    onAddLines,
    clearReservation,
    saveBithDayReservation,
    onSelectLineAndDeleteOthers,
    submitError,
  } = useBirthdayManager();

  return (
    <Grid container spacing={1}>
      {/* <Grid item xs={12} md={3}>
        <BirthdayLeftContainer
          firstStepTitle={birthDayData.mainAssorts?.title}
          activeSecondStep={Boolean(getId(firstStepMethod.assortFirstStep))}
          activeThirdStep={secondStepMethod.activeStepThree}
          activeAnotherStep={thirdStepMethod.activeStepsAnother}
        />
      </Grid> */}
      <Grid item xs={12}>
        <BirthdayRightContainer
          birthDayData={birthDayData}
          selectedAssort={firstStepMethod.assortFirstStep}
          onSelectAssort={firstStepMethod.setAssortFirstStep}
          birthDayTimeAndQnt={secondStepMethod.birthDayTime}
          onSetBirthDatTimeAndQnt={secondStepMethod.setBirthDayTime}
          activeStepThree={secondStepMethod.activeStepThree}
          setActiveStepThree={secondStepMethod.setActiveStepThree}
          birthDayDetails={thirdStepMethod.birthDayDetails}
          onSetBirthDayDetails={thirdStepMethod.setBirthDayDetails}
          activeStepsAnother={thirdStepMethod.activeStepsAnother}
          setActiveStepsAnother={thirdStepMethod.setActiveStepsAnother}
          lines={lines}
          onAddLine={onAddLines}
          saveReservation={saveBithDayReservation}
          clearReservation={clearReservation}
          onSelectLineAndDeleteOthers={onSelectLineAndDeleteOthers}
          submitError={submitError}
        />
      </Grid>
    </Grid>
  );
};

export default BirthdayReservation;
